import secureLocalStorage from "react-secure-storage";
import { GET_USER_SETTINGS } from "helpers/constants";
import dexieDB from "database/dexieDB";

export const getUserSettingsByUserID = () => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	if (currentUser) {
		try {
			if (currentUser?.loginType === "daffi") {
			} else if (currentUser?.loginType === "local") {
				const userData = await dexieDB.settings
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data?.data) {
							return data.data;
						} else return null;
					});

				dispatch({
					type: GET_USER_SETTINGS,
					payload: userData,
				});
			}
		} catch (error) {
			console.error(error);
		}
	}
};

export const updateUserSettingsByUserID = (formData, notify) => async (dispatch) => {
	const currentUser = secureLocalStorage.getItem("currentUser");

	if (currentUser) {
		try {
			if (currentUser?.loginType === "daffi") {
			} else if (currentUser?.loginType === "local") {
				const userData = await dexieDB.settings
					.filter((item) => item?.userID === currentUser?._id)
					.first()
					.then((data) => {
						if (data) {
							return data;
						} else return null;
					});

				if (userData?.data) {
					await dexieDB.settings
						.update(userData.id, { data: { ...userData?.data, ...formData } })
						.then((updateCount) => {
							if (updateCount) notify("success", "User settings updated");
							else notify("error", "User settings update failed");
						});
				} else {
					await dexieDB.settings
						.add({
							userID: currentUser?._id,
							data: formData,
						})
						.then((id) => {
							if (id) notify("success", "User settings updated");
							else notify("error", "User settings update failed");
						});
				}

				dispatch({ type: GET_USER_SETTINGS, payload: userData?.data ? { ...userData.data, ...formData } : formData });
			}
		} catch (error) {
			console.error(error);
		}
	}
};
